module.exports = __webpack_public_path__ + "static/intimaWear-ecacb63769e4127d3679dff79555d80c.png";